import React, { useEffect, useState } from "react"
import { useScope } from "../SelectProjectCompanyContainer"
import Send from "../../core/communication"
import EvidencesDetailsScreen from "../../screen/EvidencesDetailsScreen"
import { setData } from "../../core/redux/app/Actions"
import { useDispatch, useSelector } from "react-redux"
import moment from "moment"

const EvidencesDetailsContainer = () => {
  const { scope, scopeType } = useScope()
  const dispatch = useDispatch()
  const dwData = useSelector((state) => state.app.dwData)
  const usersRDX = useSelector((state) => state.app.users)
  const allUsers = useSelector((state) => state.app.allUsers)
  const [loading, setLoading] = useState(false)
  const [reload, setReload] = useState(false)
  const [evidenceDetails, setEvidenceDetails] = useState([])
  const [dw, setDw] = useState([])

  const loadData = async () => {
    setLoading(true)
    const dw = await Send.get("/dw/data", `projects='${scope?.id}'&scopeType=${scopeType}`)

    setDw(dw)
    setLoading(false)
  }

  const setToRedux = () => {
    let dw2 = []
    let users = []
    users = usersRDX

    dw2 = dw
      .filter((item) => item.Tipo_Pergunta === "file" && item.Resposta !== "Ø")
      .map((item) => {
        return {
          ...item,
          Tecnico:
            allUsers?.filter((item2) => item2?.id == item?.Tecnico)[0]?.name || item?.Tecnico,
          Produtor:
            users?.filter((item2) => item2?.id == item?.Produtor)[0]?.name || item?.Produtor,
        }
      })

    dispatch(
      setData({
        dwData: dw2,
      }),
    )
  }

  useEffect(() => {
    if (scope?.id) {
      loadData()
      setEvidenceDetails([])
    }
  }, [scope?.id, reload])

  useEffect(() => {
    setToRedux()
  }, [dw])

  useEffect(() => {
    setReload(!reload)
  }, [dw && dw.length, scope?.id])

  const getEvidenceDetails = async (e) => {
    const { alt, currentSrc } = e.target
    if (dwData.length > 0) {
      const dwfilter = dwData.filter((item) => item.Atendimento === alt)
      setEvidenceDetails(dwfilter)
    }
  }

  return (
    <EvidencesDetailsScreen
      {...{ getEvidenceDetails, evidenceDetails, loading }}
      dwData={dwData}
      dw={dw}
      evidenceDetails={getTableDetails(evidenceDetails)}
    />
  )
}

export default EvidencesDetailsContainer

const getTableDetails = (details) => {
  if (!details) {
    return []
  }

  const dataDetails = {
    etapa: {
      name: details[0]?.Etapa,
    },
    data: {
      date: moment(details[0]?.Data?.value, "YYYY-MM-DD").format("DD/MM/YYYY"),
    },
    produtor: {
      name: details[0]?.Produtor,
    },
    tec: {
      name: details[0]?.Tecnico,
    },
  }
  return [
    {
      title: "Etapa",
      value: "etapa",
      lineCaptions: ["Tipo da Etapa"],
      data: dataDetails,
    },
    {
      title: "Produtor",
      value: "produtor",
      lineCaptions: ["Nome do Produtor"],
      data: dataDetails,
    },
    {
      title: "Técnico",
      value: "tec",
      lineCaptions: ["Nome do Técnico"],
      data: dataDetails,
    },
  ]
}
